/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetIoePreviewFindings200ResponseFindingsInner } from './GetIoePreviewFindings200ResponseFindingsInner';
import {
    GetIoePreviewFindings200ResponseFindingsInnerFromJSON,
    GetIoePreviewFindings200ResponseFindingsInnerFromJSONTyped,
    GetIoePreviewFindings200ResponseFindingsInnerToJSON,
    GetIoePreviewFindings200ResponseFindingsInnerToJSONTyped,
} from './GetIoePreviewFindings200ResponseFindingsInner';

/**
 * Successful response
 * @export
 * @interface GetIoePreviewFindings200Response
 */
export interface GetIoePreviewFindings200Response {
    /**
     * 
     */
    findings?: Array<GetIoePreviewFindings200ResponseFindingsInner>;
}

/**
 * Check if a given object implements the GetIoePreviewFindings200Response interface.
 */
export function instanceOfGetIoePreviewFindings200Response(value: object): value is GetIoePreviewFindings200Response {
    return true;
}

export function GetIoePreviewFindings200ResponseFromJSON(json: any): GetIoePreviewFindings200Response {
    return GetIoePreviewFindings200ResponseFromJSONTyped(json, false);
}

export function GetIoePreviewFindings200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIoePreviewFindings200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'findings': json['findings'] == null ? undefined : ((json['findings'] as Array<any>).map(GetIoePreviewFindings200ResponseFindingsInnerFromJSON)),
    };
}

export function GetIoePreviewFindings200ResponseToJSON(json: any): GetIoePreviewFindings200Response {
    return GetIoePreviewFindings200ResponseToJSONTyped(json, false);
}

export function GetIoePreviewFindings200ResponseToJSONTyped(value?: GetIoePreviewFindings200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'findings': value['findings'] == null ? undefined : ((value['findings'] as Array<any>).map(GetIoePreviewFindings200ResponseFindingsInnerToJSON)),
    };
}

